<template>
    <div class="tablist-four h-100 position-relative">
        <div class="headerTitle d-flex align-items-center justify-content-between mb-1">
            <h6>{{$t('economic_calendar') }} </h6>
            <span class="iconResize opacityIco"><feather size="16px" type="calendar"></feather> </span>
        </div>
        <div class="leftData news scrollbar">
            <app-loader v-if="pageLoader && Object.keys(economicCalData).length == 0"/>
            <no-data class="noData mt-4 h-100 d-flex justify-content-center flex-column" v-else-if="Object.keys(economicCalData).length == 0" text="Opps! <span>no data</span>"/>
            <div class="accordianCal" :class="(selIndex == index)?'active':' '" v-for="list,key,index in economicCalData" v-if="Object.keys(economicCalData).length">
                <p @click.prevent="(selIndex != index)?selIndex = index:selIndex = -1" class="m-0 d-flex align-items-center justify-content-between themeBG">
                    {{key | moment("dddd, DD MMMM YYYY")}} 
                    <span class="arrow" v-if="$route.name == 'custom-view'">
                        <feather size="15px" type="chevron-down" v-if="selIndex == index"></feather>
                        <feather size="15px" type="chevron-up"  v-else></feather>
                    </span>
                    <span class="arrow" v-else>
                        <feather size="15px" type="chevron-down"></feather>
                    </span>
                </p>
                <div class="showCal border-bottom" :class="[{'border-top':index1 == 0}]" v-for="calenderDatewise,index1 in list" v-if="selIndex == index">
                    <div class="d-flex">
                        <span class="crncyIcon" v-if="calenderDatewise.Country">
                            <img :src="'../../../../../static/website/images/country_images/'+calenderDatewise.Country.toLowerCase()+'.svg'" alt="" />
                        </span>
                        <span class="rightText">
                            <h5 class="m-0">{{calenderDatewise.Event || '-'}}</h5>
                            <p class="small m-0 d-block">{{Getdate(calenderDatewise.Date)}}</p>
                        </span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center text-center mt-1">
                        <div class="inblt">
                            <span>{{$t('actual') }} </span>
                            <h5>{{calenderDatewise.Actual || '-'}}</h5>
                        </div>
                        <div class="inblt">
                            <span>{{$t('previous') }} </span>
                            <h5>{{calenderDatewise.Previous || '-'}}</h5>
                        </div>
                        <div class="inblt">
                            <span>{{$t('forecast') }} </span>
                            <h5>{{calenderDatewise.Forecast || '-'}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script> 
    import moment from 'moment'
	import { commonAllmixins } from '@/plugins/commonAll'
	export default {
		name: 'Economic-Calender',
		mixins: [commonAllmixins],
		data() {
			return {
				pageLoader : false,
				priority : '1',
				selIndex : 0,
				//========================================== 
				pageLimit : '15',
				search : '',
				page : 1,
                date:[Date.now(),new Date(Date.now() + 15*24 * 3600 * 1000)],
			}
		},
		methods:{
			Getdate(key){
                let d = new Date(key);
                return moment(d).format('hh:mm a')
            },
            listing(){
                let inputJson = {
	                'globalParams' : {
	                    filter: {'from':this.date[0] ,'to':this.date[1],'priority':this.priority,'countries':this.countries },
	                    sort: [],
	                    search: this.search,
	                    page: this.page,
	                    perPage: parseInt(this.pageLimit),
	                    offset : (new Date().getTimezoneOffset())
	                },
	                'localParams' : {'parameter' : this}
                }
                this._runGetEconomicCalData(inputJson)
            },
		},
		created(){
            if(Object.keys(this.economicCalData).length == 0){
                this.listing()
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/user/home-elements/Economic-Calendar.vue